const APP = require('APP')
const $ = require('jquery')
const _ = require('underscore')
const Backbone = require('backbone')

const { ajax, getJson } = require('ajax')
const trans = require('trans')
const numbers = require('numbers')
const router = require('router')
const win = require('Helpers/win')
const errorHandler = require('Helpers/errorHandler')
const { gaHelper } = require('../../../app/containers/AnalyticsGoogleTag/gaHelper')

module.exports = Backbone.Model.extend({
  constructor: function constructor(view, gameModel, messages) {
    this.view = view
    this.gameModel = gameModel
    this.playingForFun = view.forFun
    this.messages = messages

    this.format = this.gameModel.get('format')
  },

  init() {
    this.inited = true
  },

  /**
   * Method to run game play
   * play -> prepare -> getConfig -> isReady -> gameReady(if Hhtml5) -> runGame
   * @param  {boolien} forFun
   */
  play() {
    if (!this.gameModel.get('isPlayPermitted')) {
      gaHelper.addError(4300100, this.gameModel.get('name') + (this.playingForFun ? ' for fun' : ''))
      // eslint-disable-next-line no-alert
      alert(trans("You can't play this game."))
      return
    }

    if (this.canRunGame()) {
      gaHelper.sendGATimeEvent(`${this.gameModel.get('name')} load ${this.format}`)

      this.getConfig()
        .then(this.parseConfig.bind(this))
        .then(this.isReady.bind(this))
        .then(this.runGame.bind(this))
        .catch(this.initError.bind(this))
    }
  },

  /**
   * checking available, credits and login
   * @param  {Function} callback
   * @return {bool}
   */
  canRunGame() {
    if (!this.inited) {
      this.init()
    }

    return true
  },

  /**
   * getting config - flashvars etc...
   * @param  {Function} callback
   * @return {Object}
   */
  getConfig() {
    return new Promise((resolve, reject) => {
      if (APP.gameInitData && APP.gameInitData.config) {
        // TESTING ERRORS
        // APP.gameInitData = {config: {error:'game_default_error'}};
        resolve({ data: APP.gameInitData.config })
      } else {
        // resolve({config: {error:'please contact us in case of problems'}});
        // reject({config: {error:'game_default_error'}});
        ajax.getJson(
          [
            'game_config',
            {
              forFun: this.playingForFun,
              gameId: this.gameModel.get('number'),
            },
          ],
          resolve,
          reject,
        )
      }
    })
  },

  /**
   * parsing config - in flash and html5 models
   * @param  {[type]} config [description]
   */
  parseConfig(data) {
    return new Promise((resolve, reject) => {
      if (data && !_.isObject(data.data)) {
        reject(data)
        return
      }

      const config = data.data

      if (config.error) {
        reject(config)
        return
      }

      resolve(config)
    })
  },

  /**
   * is ready for game redy in html5 games
   * @param  {Function} callback [description]
   */
  isReady(config) {
    return new Promise((resolve) => {
      resolve(config)
    })
  },

  /**
   * Runs where all configs are loaded and game is ready
   * @param  {[type]} config game congif | flash config with flashvars
   */
  runGame(config) {
    /** RESET init data - ist actual only on first game run */
    if (APP.gamePlayPage) {
      APP.gamePlayPage.firstRun = false
    }
    APP.gameInitData = undefined

    this.config = config
    this.createGlobalGameObj()
    this.view.run(config)

    gaHelper.addInfo(`${this.gameModel.get('name')} play ${this.playingForFun ? 'for fun' : 'for real'}`, this.format)
  },

  /**
   * All errors are cached here
   */
  initError(config) {
    // eslint-disable-next-line no-console
    console.log(config)
    if (config.error) {
      this.messages.handleError(config.error, 'Q')
    } else if (config.success === false && config.data.code) {
      const err = errorHandler.getErrorByCode(config.data.code, config.data.message)
      this.messages.handleError(err, 'Q')
    } else {
      this.messages.handleError(trans('unknown_error'), 'Q')
    }
  },

  /**
   * game askt it if can play
   * alsow, if user playing for fun, counting forFunGameNo
   * and displaying long for fun game message
   * @return {[type]} [description]
   */
  canPlay() {
    if (this.playingForFun) {
      /** PLAYING FOR FUN */
      return true
    } else {
      /** PLAYING FOR REAL */
      this.gameModel.trigger('PLAY_FOR_REAL')
    }

    return true
  },

  onInitCompleted(xml) {
    this.gameModel.trigger('ON_INIT_COMPLETED')

    if (_.isString(xml) && xml.length === 19) {
      // TODO tymczasowo
      this.registerSID(xml)
    } else {
      const $xml = $(xml)
      const recoveryInfo = {
        status: $xml.find('RecoveryInfo Status').text().trim(),
        savedAt: $xml.find('RecoveryInfo SavedAt').text().trim(),
      }

      if (recoveryInfo.status.toLowerCase() === 'RECOVERY_NOT_FINISHED_GAME') {
        this.messages.recoveryInfo(recoveryInfo)
      }

      this.registerSID($xml.find('GameSessionId').text().trim())
    }

    if (this.format === 'flash') {
      gaHelper.sendGATimeEvent(`${this.gameModel.get('name')} load flash`, true)
    }
  },

  registerSID(sid) {
    this.sessionId = sid
  },

  hide() {
    this.view.hide()
  },

  destroy() {
    this.view = undefined
    this.messages = undefined

    try {
      window.closeGame()
    } catch (err) {
      // eslint-disable-next-line no-console
      console.log(err)
    }
  },

  sendCloseMsg(callback) {
    ajax(['game_close'], {
      always() {
        callback()
      },
    })
    this.sessionId = undefined
  },

  resetTimeLimit(callback) {
    getJson(
      ['multilotto_timelimit_reset'],
      () => {
        this.callGame('confirmPlay')
        if (_.isFunction(callback)) {
          callback()
        }
        this.view.show()
      },
      this.view.destroy.bind(this.view),
    )
  },

  handleMessage(message, action, demoMode, callback) {
    const errorCode = errorHandler.getErrorCodeFromMsg(message)
    const error = errorHandler.getErrorByCode(errorCode, window.DEBUG && message)
    // console.log('handleMessage', message, action, errorCode, error);
    this.messages.handleError(error, action, demoMode, callback)
  },

  handleError(xml, demoMode, callback) {
    const $xml = $(xml)
    const action = $xml.find('Action').text()
    const message = $xml.length ? $xml.find('Message').text() : xml
    const code = Number($xml.find('code').text())
    const trackId = $xml.length ? $xml.find('TrackId').text() : undefined

    const error = errorHandler.getErrorByCode(code, window.DEBUG && message)

    this.messages.handleError(error, action, demoMode, callback, trackId)
  },

  callGame() {},

  getCommandBaseParameters() {
    return `forFun=${this.playingForFun ? '1' : '0'}&${this.config.flashvars.commandBaseParameters}`
  },

  /**
   * Creating window.GAME obj;
   */
  createGlobalGameObj() {
    // INTERFACE TO FLASH/HTML GAMES
    window.GAME = window.GAME || {}

    window.GAME.canPlay = this.canPlay.bind(this)
    window.GAME.gameClose = this.view.destroy.bind(this.view)
    window.GAME.handleMessage = this.handleMessage.bind(this)
    window.GAME.handleError = this.handleError.bind(this)
    window.GAME.onInitCompleted = this.onInitCompleted.bind(this)
    window.GAME.gameFullscreen = win.fullscreen

    if (this.playingForFun && this.config.showCurrencyForFun !== true) {
      window.GAME.money = numbers.creditsToNumberFormat
    } else {
      window.GAME.money = numbers.creditsToMoney
    }

    window.GAME.payout = function payout() {
      router.pathRedirect('multilotto_payment_withdrawal_make')
    }

    window.GAME.sendAnaliticsEvent = function sendAnaliticsEvent(action, label) {
      gaHelper.addInfo(action, label)
    }
  },
})
